import type { CSSProperties } from 'react'
import { pubSubWhiteboard } from './pubSub'

export enum WhiteboardEvent {
    UPDATE = 'update',
}

export type Whiteboard = {
    identifier?: string | number
    loading?: boolean
    open: boolean
    style?: CSSProperties
    showAvatar?: boolean
}

export type WhiteboardState = {
    whiteboard: Whiteboard
}

export const WHITEBOARDSTATE: WhiteboardState = {
    whiteboard: {
        loading: false,
        open: false,
        identifier: undefined,
    },
}

const emitWhiteboardUpdate = (whiteboard: Whiteboard, immediate = true) => {
    WHITEBOARDSTATE.whiteboard = whiteboard
    // WHITEBOARDSTATE.identifier = state.identifier
    // WHITEBOARDSTATE.loading = state.loading
    // WHITEBOARDSTATE.open = state.open
    // WHITEBOARDSTATE.showAvatar = state.showAvatar
    // WHITEBOARDSTATE.style = state.style
    pubSubWhiteboard.emit(WhiteboardEvent.UPDATE, whiteboard, immediate)
}

export const openWhiteboard = (
    identifier: string | number,
    showAvatar?: boolean,
    style?: CSSProperties,
) => {
    const whiteboardState = {
        ...WHITEBOARDSTATE.whiteboard,
        identifier,
        open: true,
        showAvatar,
        style,
    }
    emitWhiteboardUpdate(whiteboardState, true)
}

export const closeWhiteboard = () => {
    const whiteboardState = {
        ...WHITEBOARDSTATE,
        open: false,
    }
    emitWhiteboardUpdate(whiteboardState, true)
}
